import React from "react";
import { MAP_HEIGHT, MAP_WIDTH, projectCoordinates } from "../lib/mapProjection";
import "./TravelMap.css";

type Place = [name: string, latitude: number, longitude: number];

export default function TravelMap({ places }: { places: readonly Place[] }) {
  return (
    <svg
      className="travel-map"
      viewBox={`0 0 ${MAP_WIDTH} ${MAP_HEIGHT}`}
      width={MAP_WIDTH}
      height={MAP_HEIGHT}
      role="img"
      aria-label="Map of places Montgomery has visited"
    >
      {/* The land and markers scale together, with no CSS offsets or cropping. */}
      <image
        href={`${process.env.PUBLIC_URL}/world-map.svg`}
        width={MAP_WIDTH}
        height={MAP_HEIGHT}
        aria-hidden="true"
      />
      <g aria-hidden="true">
        {places.map(([name, latitude, longitude]) => {
          const { x, y } = projectCoordinates(latitude, longitude);
          return (
            <circle
              key={name}
              data-place={name}
              className="travel-map-dot"
              cx={x}
              cy={y}
              r="1.45"
            />
          );
        })}
      </g>
    </svg>
  );
}
